import { ComponentProps } from 'react';
import { useDepartmentSelector } from '../../hooks';
import { DepartmentSelectorState, DepartmentSelector as StandaloneDepartmentSelector } from '../department-selector';
import { useThreadHeaderContext } from '../thread-header';

type DepartmentSelectorProps = Omit<
  ComponentProps<typeof StandaloneDepartmentSelector>,
  keyof DepartmentSelectorState | 'onSelectDepartment' | 'variant'
>;

export const DepartmentSelector = (rest: DepartmentSelectorProps) => {
  const { groupId, personPhone, outboundPhone, onOutboundPhoneChange, variant } = useThreadHeaderContext();

  const departmentSelectorState = useDepartmentSelector({
    groupId,
    departmentId: outboundPhone?.departmentId,
    alwaysShow: false,
    personPhone,
  });

  if (!onOutboundPhoneChange) return null;

  return (
    <StandaloneDepartmentSelector
      {...departmentSelectorState}
      onSelectDepartment={onOutboundPhoneChange}
      variant={variant}
      {...rest}
    />
  );
};
